'use client';
import useTranslation from '@repo/ui/src/context/Translation/useTranslation';
import dynamic from 'next/dynamic';
import { classNames } from '@repo/ui/src/utils/classNames';
import Button from '@repo/ui/src/components/Button';
import { CTAButtonProps, LinkProps } from '@repo/ui/src/types';
import { Anchor } from '@repo/ui/src/components/Anchor';

const ShopLocalIcon = dynamic(() => import('@repo/ui/src/components/Icons/ShopLocalIcon'));

interface Props {
  buttonProps?: CTAButtonProps;
  icon?: boolean;
  hasLongText?: boolean;
}

const ShopLocalButton = ({ buttonProps, icon = false, hasLongText }: Props) => {
  const { t } = useTranslation();

  const buttonStaticContent = t<LinkProps>(
    'productDetailPageContent.dealerLocatorLink.link',
    undefined,
    {
      default: { link: 'dealers' },
      returnObjects: true,
    },
  );
  return (
    <Button
      {...buttonStaticContent}
      {...buttonProps}
      as={Anchor}
      className={classNames('tw-grid tw-gap-x-2 tw-grid-flow-col', buttonProps?.className)}
    >
      {icon && <ShopLocalIcon className="tw-text-brand-300" />}
      {hasLongText ? (
        <span className="tra-text-web-utl-link tw-underline !tw-px-0 hover:tw-text-brand-400">
          {t('productDetailPageContent.shopLocalLongText', undefined, {
            default: 'Shop this and more at your local dealer',
          })}
        </span>
      ) : (
        <span>
          {t('productDetailPageContent.shopLocalText', undefined, {
            default: 'shop local',
          })}
        </span>
      )}
    </Button>
  );
};

export default ShopLocalButton;
